import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';
import CampaignModel from 'cio/models/campaign';
import { action } from '@ember/object';

export default class CampaignOverviewSubjectsIndexController extends Controller {
  @service auth!: AuthService;

  declare model: CampaignModel;

  @tracked continuation: null | string = null;

  @action
  updateMeta(meta: { continuation: null | string }) {
    this.continuation = meta.continuation;
  }
}
